import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Create, FileCopySharp } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import moment from 'moment';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsPost } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'Periodo', width: 100 },
  { Header: 'Cod. Prov', accessor: 'CardCode', width: 180 },
  { Header: 'Proveedor', accessor: 'CardName' },
  { Header: 'Zonal', accessor: 'zonal', width: 150 },
  { Header: 'Sede', accessor: 'zone', width: 180 },
  { Header: 'Tipo', accessor: 'tipo', width: 150 },
  { Header: 'Cuota', accessor: 'cuota', excelEnabled: false },
  { Header: 'Cuota', accessor: 'cuota_string', hidden: true },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Sede(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [cuotas, setCuotas] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [currentPeriod, setCurrentPeriod] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [processing, setProcessing] = useState(false);

  const handleChange = (id, field, value) => {
    const index = cuotas.findIndex((item) => item.id == id);
    cuotas[index][field] = value;
    setCuotas([...cuotas]);
  };
  async function loadCuotas(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/cuota-sede-clorox', filter);
    setDataLoading(false);
    if (response.success) setCuotas(response.data);
  }

  async function updateCuota(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/cuota-sede-clorox', id, { Periodo: valueSearch.Periodo, [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data)
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }
  
  async function transferirRegistros(sourcePeriodo, targetPeriodo) {
    setDataLoading(true);
    setProcessing(true);
    let response = await wsPost('sale/cuota-sede-clorox/transferir-registros', {
      SourcePeriodo: sourcePeriodo,
      TargetPeriodo: targetPeriodo,
    });
    setDataLoading(false);
    setProcessing(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Transferencia exitosa: ', response.data);
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
      console.error('Error al transferir registros: ', response);
    }
  }

  const handleFilterChange = (value) => {
    const period = parseInt(moment(value.Periodo).format('YYYYMM'), 10);
    setCurrentPeriod(period);
  };

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadCuotas(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de cuotas clorox por sede{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadCuotas}
              getValueSearch={(value) => {
                setValueSearch(value);
                handleFilterChange(value);
              }}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="Periodo"
            />
            <Button
              color="danger"
              onClick={() => {
                const sourcePeriod = moment(currentPeriod.toString(), "YYYYMM").subtract(1, "month").format("YYYYMM");
                transferirRegistros(Number(sourcePeriod), currentPeriod);
              }}
              disabled={processing}
            >
              Inicializar cuotas de sede
            </Button>
            <ReactTable
              excelName="cuotas_de_proveedor"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={cuotas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}>
                        <Button justIcon round simple color="warning" onClick={() => setOpen(item)}>
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/cuota-sede-clorox"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            loadCuotas(valueSearch).then(() => setDataLoading(false));
                        }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  Periodo: item.Periodo,
                  CardCode: item.business_partner?.CardCode,
                  CardName: item.business_partner?.CardName,
                  cuota_string: item.cuota,
                  zonal: item.zonal,
                  tipo: item.tipo == 'O' ? 'Venta' : item.tipo == 'C' ? 'Cobertura' : 'Compra',
                  zone: item.zone?.description,
                  cuota: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.cuota}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="cuota"
                        margin="normal"
                        value={item.cuota || ''}
                        onChange={(e) => handleChange(item.id, 'cuota', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'cuota', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
